import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthenticationService } from "../business/user/authentication.service";

// 🔑 Ajout du token dans chaque requête
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private auth: AuthenticationService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.auth.getToken();
        const isAuthRoute = req.url.includes('/Authentication/');
        const isSwitchUserRoute = req.url.includes('/SwitchUser');
        if (token && (!isAuthRoute || isSwitchUserRoute)) {
            req = req.clone({
                setHeaders: { Authorization: `Bearer ${token}` }
            });
        }

        return next.handle(req);
    }
}